
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/near-me",
      function () {
        return require("private-next-pages/near-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/near-me"])
      });
    }
  